import { SystemAuthorizations } from 'shell/authorizations/system';
import { HeadCell } from 'shell/components/shared/table/types';
import { EventRegistrationClient } from './types';
import * as yup from 'yup';

export const authsObj = Object.freeze({
  read: [SystemAuthorizations.IscrizioneEventoQuery],
  create: [SystemAuthorizations.IscrizioneEventoAdd],
  edit: [SystemAuthorizations.IscrizioneEventoUpdate],
  delete: [SystemAuthorizations.IscrizioneEventoDelete],
});

export const validationSchemaEventRegistrationFilter = yup.object({});

export const headCells: HeadCell<EventRegistrationClient, keyof EventRegistrationClient>[] = [
  {
    id: 'eventCode',
    label: 'Tipo Evento',
  },
  {
    id: 'eventDescription',
    label: 'Descrizione Tipo Evento',
  },
  {
    id: 'destinationCode',
    label: 'Tipo Destinazione',
  },
  {
    id: 'destinationDescription',
    label: 'Descrizione Tipo Destinazione',
  },
  {
    id: 'subscriberCode',
    label: 'Sottoscrittore',
  },
  {
    id: 'subscriberDescription',
    label: 'Descrizione Sottoscrittore',
  },
  {
    id: 'progressive',
    label: 'Progr',
  },
  {
    id: 'action',
    label: '',
  },
];
